import {lazy} from '@aboutyou/lazy-imports';

export const DatadogRUMRouteTracker = lazy(() =>
  import('./DatadogRUMRouteTracker.eager').then(mod => ({
    default: mod.DatadogRUMRouteTracker,
  })),
);
